import Vue from 'vue'
import PubApp from './PubApp'
import VueRouter from 'vue-router'
import accounting from 'accounting'

import $ from 'jquery'
window.$ = $
window.jQuery = $

import {isThisBrowserSupported, getBrowserVersion} from './browser-detect'

if (!isThisBrowserSupported()) {
  $('body').prepend(`You are using an unsupported browser: ${getBrowserVersion()}`)
  $('#app').hide()
}

import Activation from './components/common/Activation'
import ActivationForm from './components/common/ActivationForm'
import Login from './components/public/Login'
import Logout from './components/public/Logout'
import ForgotPassword from './components/public/ForgotPassword'
import ResetPassword from './components/public/ResetPassword'

// Vue.config.debug = true
// Vue.config.devtools = true

// Materialize select binding workaround
Vue.directive('select', {
  'twoWay': true,
  'bind': function() {
    $(this.el).material_select()
    var self = this
    $(this.el).on('change', function() {
      self.set($(self.el).val())
    })
  },
  update: function(newValue, oldValue) {
    $(this.el).val(newValue)
  },
  unbind: function() {
    $(this.el).material_select('destroy')
  }
})

Vue.filter('thousandSeparated', {
  read: function(val) {
    if (val === null) {
      return ''
    }
    return accounting.formatNumber(val, 0, ' ')
  },
  write: function(val, oldVal) {
    if (val === '') {
      return null
    }
    return accounting.unformat(val)
  }
})

$(document).ready(() => {
  // handling chrome autofill problem
  $('input').on('change.autofill', function() {
    $('[for=password]').addClass('active')
  }).click(function() {
    $(this).unbind('change.autofill')
  })

  Vue.use(VueRouter)

  const router = new VueRouter({
    history: true
  })

  // Pointing routes to the components they should use
  router.map({
    '/login': {
      component: Login
    },
    '/logout': {
      component: Logout
    },
    '/forgot-password': {
      component: ForgotPassword
    },
    '/reset-password': {
      component: ResetPassword
    },
    '/activation-form': {
      component: ActivationForm
    },
    '/activate/:type/:id/:code': {
      component: Activation
    }
  })

  // Any invalid route will redirect to home
  router.redirect({
    '*': '/login'
  })

  router.start(PubApp, '#app')
})



// WEBPACK FOOTER //
// ./src/public-main.js